import App from './Vue/App';

export const vm = new App({
    el: '#riki-community',
});
